import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { StatsBar } from "@/components/StatsBar";
import { About } from "@/components/About";
import { CompaniesGrid } from "@/components/CompaniesGrid";
import { Brokerage } from "@/components/Brokerage";
import { CompanySections } from "@/components/CompanySections";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-white text-black" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <CompaniesGrid />
        <Brokerage />
        <CompanySections />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
